import { COLOR_PALETTE } from '@inflearn/ds-react-next';
import {
  type IconDefinition,
  faCheck,
  faClose,
  faInfoCircle,
} from '@inflearn/pro-regular-svg-icons';
import { validateSync } from 'class-validator';
import _ from 'lodash-es';

/** @see {@link https://inflab.atlassian.net/wiki/spaces/s9BCy8MccKi7/pages/1201537050#%EB%B3%80%EA%B2%BD%EC%A0%90-%ED%95%B5%EC%8B%AC-%EA%B8%B0%EC%A1%B0} */
export type ValidationStatus = 'help' | 'error' | 'success' | 'info';

export type ValidationMessage<T> = {
  type: T;
  status: ValidationStatus;
  message: string;
};

export const getValidationColor = (status: ValidationStatus) => {
  const colors: Record<ValidationStatus, string | string[]> = {
    help: COLOR_PALETTE.gray[6],
    error: COLOR_PALETTE.red[6],
    success: COLOR_PALETTE.infgreen[6],
    info: COLOR_PALETTE.blue[6],
  };

  return colors[status] as keyof typeof COLOR_PALETTE;
};

export const getValidationIcon = (status: ValidationStatus) => {
  const icons: Record<ValidationStatus, IconDefinition> = {
    help: faCheck,
    error: faClose,
    success: faCheck,
    info: faInfoCircle,
  };

  return icons[status];
};

export const getErrorConstraints = (validator: object, property: string) =>
  _.find(validateSync(validator), {
    property,
  })?.constraints;

export const getValidationMessages = <T extends string>(
  validationTypes: T[],
  validator: object,
  property: string,
): ValidationMessage<T>[] => {
  const constraints = getErrorConstraints(validator, property);

  return _.map(validationTypes, (key) => ({
    type: key,
    status: 'help',
    message: _.isUndefined(constraints) ? '' : constraints[key],
  }));
};
